import { lazy } from 'react'

const VehicleManagement = lazy(
  () => import('pages/TRMManagement/VehicleManagement/VehicleManagement')
)
const DriverManagement = lazy(
  () => import('pages/TRMManagement/DriverManagement')
)
const TimeShiftManagement = lazy(
  () => import('pages/TRMManagement/ShiftMnagement/index')
)
const TRMMoveVehicle = lazy(() => import('pages/TRMMoveVehicle/TRMMoveVehicle'))

const ChangeDriver = lazy(() => import('pages/change-driver'))
const ShiftDetailManagement = lazy(
  () => import('pages/TRMManagement/shift-detail-management')
)

const CancelDriverAllocation = lazy(
  () => import('pages/cancel-driver-allocation')
)
export const childs: Array<ISideBarChild> = [
  {
    code: '',
    to: '/vehicle-management',
    component: <VehicleManagement />,
    label: 'مدیریت نقلیه',
    permissions: 'view_vehicle_management',
  },
  {
    to: '/driver-management',
    component: <DriverManagement />,
    label: 'مدیریت رانندگان',
    permissions: 'view_driver_management',
  },
  {
    code: '',
    to: '/time-shift-manage',
    component: <TimeShiftManagement />,
    label: 'مدیریت شیفت',
    permissions: 'view_shift_mnagement',
  },

  {
    code: '',
    to: '/Move-vehicle',
    component: <TRMMoveVehicle />,

    label: 'جابجایی وسیله نقلیه',
    permissions: 'view_vehicle_transfer',
  },
  // {
  //   code: '',
  //   to: '/change-driver',
  //   component: <ChangeDriver />,
  //   label: 'تعویض راننده',
  //   permissions: '',
  // },
  {
    code: '',
    to: '/shift-detail-manage',
    component: <ShiftDetailManagement />,
    label: 'مدیریت شیفت فریلنسر',
    permissions: 'view_freelancer_shift_detail',
  },
  {
    code: '',
    to: '/cencel-driver-allocation',
    component: <CancelDriverAllocation />,
    label: 'لغو تخصیص  راننده فریلنسر',
    permissions: 'view_cancel_freelancer_shift',
  },
]
